import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

function TestimonialThree() {
    return (
        <div>
            {/* testimonials area start */}
            <div className="rts-testimonials-h2-area rts-section-gap bg_testimonials-h2">
                <div className="container">

                    <div className="row mb--30">
                        <div className="col-12">
                            <div className="title-area testimonials-area-h2 text-center">
                                <span>Depoimentos Reais</span>
                                <h2 className="title">O que nossos clientes dizem</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row g-5">
                        <div className="col-12">
                            {/* Swiper */}
                            <div className="swiper testimonials-h2">
                                
                                <Swiper
                                    modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                                    className="testimonials-h2"
                                    speed={700}
                                    slidesPerView={1}
                                    spaceBetween={30}
                                    loop={true}
                                    autoplay={true}
                                    pagination={{
                                        clickable: true,
                                        el: 'swiper-pagination2'
                                    }}
                                    breakpoints={{
                                        1200: { slidesPerView: 2 },
                                        900: { slidesPerView: 2 },
                                        768: { slidesPerView: 1 },
                                        580: { slidesPerView: 1 },
                                        450: { slidesPerView: 1 },
                                        0: { slidesPerView: 1 },
                                    }}
                                >

                                    {/* Depoimento 1 – Empresarial */}
                                    <SwiperSlide>
                                        <div className="single-testimonials-h2">
                                            <div className="body">
                                                <h5 className="title">Solução Estratégica Empresarial</h5>
                                                <p className="disc">
                                                    “A parceria com o GB Grupo foi decisiva para destravarmos um financiamento que
                                                    buscávamos há meses. A equipe entendeu nossa estrutura, analisou nossos indicadores
                                                    e nos conectou às melhores opções de crédito. Hoje conseguimos expandir nosso parque
                                                    fabril com segurança.”
                                                </p>
                                            </div>

                                            <div className="footer">
                                                <div className="left">
                                                    <a className="thumbnail" href="#">
                                                        <img src="assets/images/testimonials/07.png" alt="testimonial_gb" />
                                                    </a>
                                                    <div className="desig">
                                                        <a href="#"><h6 className="title">Renato Silveira</h6></a>
                                                        <p>Diretor Financeiro — <span>Indústria de Equipamentos</span></p>
                                                    </div>
                                                </div>

                                                <div className="right">
                                                    <div className="stars-area">
                                                        <ul>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    {/* Depoimento 2 – Agronegócio */}
                                    <SwiperSlide>
                                        <div className="single-testimonials-h2">
                                            <div className="body">
                                                <h5 className="title">Crédito Rural e Estratégia</h5>
                                                <p className="disc">
                                                    “O GB Agro trouxe clareza e estratégia para o nosso planejamento. Conseguimos acesso
                                                    a linhas de crédito rural com taxas mais competitivas e prazos que se encaixaram
                                                    perfeitamente no ciclo da nossa produção. Uma consultoria realmente especializada
                                                    no agronegócio.”
                                                </p>
                                            </div>

                                            <div className="footer">
                                                <div className="left">
                                                    <a className="thumbnail" href="#">
                                                        <img src="assets/images/testimonials/07.png" alt="testimonial_gb" />
                                                    </a>
                                                    <div className="desig">
                                                        <a href="#"><h6 className="title">Ana Cláudia Moraes</h6></a>
                                                        <p>Produtora Rural — <span>Grãos e Pecuária</span></p>
                                                    </div>
                                                </div>

                                                <div className="right">
                                                    <div className="stars-area">
                                                        <ul>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    {/* Depoimento 3 – Inteligência de Mercado */}
                                    <SwiperSlide>
                                        <div className="single-testimonials-h2">
                                            <div className="body">
                                                <h5 className="title">Estratégia e Informação</h5>
                                                <p className="disc">
                                                    “A equipe da GB Inteligência de Mercado nos entregou análises precisas e cenários
                                                    econômicos que foram fundamentais para nossa tomada de decisão. Pela primeira vez
                                                    tivemos acesso a relatórios realmente estratégicos, que conversam com a realidade
                                                    da empresa.”
                                                </p>
                                            </div>

                                            <div className="footer">
                                                <div className="left">
                                                    <a className="thumbnail" href="#">
                                                        <img src="assets/images/testimonials/07.png" alt="testimonial_gb" />
                                                    </a>
                                                    <div className="desig">
                                                        <a href="#"><h6 className="title">Marcelo Figueiredo</h6></a>
                                                        <p>CEO — <span>Grupo de Serviços Logísticos</span></p>
                                                    </div>
                                                </div>

                                                <div className="right">
                                                    <div className="stars-area">
                                                        <ul>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    {/* Depoimento 4 – Crédito Imobiliário / PF */}
                                    <SwiperSlide>
                                        <div className="single-testimonials-h2">
                                            <div className="body">
                                                <h5 className="title">Crédito Imobiliário</h5>
                                                <p className="disc">
                                                    “Eu nunca imaginei que conseguiria acessar uma linha de crédito imobiliário tão
                                                    vantajosa. A equipe do GB Crédito cuidou de tudo, desde a análise inicial até a
                                                    aprovação final, sempre com muita transparência. A diferença é o atendimento
                                                    consultivo.”
                                                </p>
                                            </div>

                                            <div className="footer">
                                                <div className="left">
                                                    <a className="thumbnail" href="#">
                                                        <img src="assets/images/testimonials/07.png" alt="testimonial_gb" />
                                                    </a>
                                                    <div className="desig">
                                                        <a href="#"><h6 className="title">Juliana Ribeiro</h6></a>
                                                        <p>Cliente PF — <span>Crédito Imobiliário</span></p>
                                                    </div>
                                                </div>

                                                <div className="right">
                                                    <div className="stars-area">
                                                        <ul>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                            <li><i className="fas fa-star" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="swiper-pagination2" />
                    </div>
                </div>
            </div>
            {/* testimonials area end */}
        </div>
    )
}

export default TestimonialThree
